import { Link } from 'react-router-dom';
import Navbar from '@/components/help-center/Navbar';
import Footer from '@/components/help-center/Footer';

export default function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Navbar />
      <main className="flex flex-1 flex-col items-center justify-center gap-4 px-6 py-24 text-center">
        <h1 className="font-poppins text-3xl font-bold text-gray-900">Página não encontrada</h1>
        <p className="max-w-md font-inter text-gray-600">
          O conteúdo que procura não existe ou foi movido.
        </p>
        <Link
          to="/"
          className="rounded-xl bg-indigo-600 px-5 py-2.5 font-poppins text-sm font-semibold text-white hover:bg-indigo-700"
        >
          Voltar ao início
        </Link>
      </main>
      <Footer />
    </div>
  );
}
